// Lands the browser after the BORICA BACKREF 303-redirect. <PaymentReturn>
// parses the returnUrl params and re-fetches the authoritative PaymentOrder.

import { PaymentReturn } from '@podium/platform/payments'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/checkout/return')({
  component: CheckoutReturnPage,
})

function CheckoutReturnPage() {
  return (
    <PaymentReturn>
      {({ params, order, isLoading }) => (
        <div>
          <h1>Payment {(order?.status ?? params.status ?? 'PENDING').toLowerCase()}</h1>
          {isLoading && <p>Confirming…</p>}
          {order && (
            <p>
              Order {order.number} — {order.status}
            </p>
          )}
          {params.providerRef && <p>Reference: {params.providerRef}</p>}
          {params.cardholderInfo && <p>{params.cardholderInfo}</p>}
        </div>
      )}
    </PaymentReturn>
  )
}
